<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="!!item && item.is_archived === 0"
    :submit="submit"
    :full-screen="true"
    :submit-btn-text="'Save'"
    :cancel-btn-text="'Close'"
    :persistent="true"
  >
    <template slot="header">
      <!-- <span>Service Request - {{ item.id }}</span> -->
    </template>
    <template slot="body">
      <div class="d-flex justify-center">
        <div
          class="d-flex flex-column ga-5"
          style="max-width: 2000px; width: 1500px;"
        >
          <div class="d-flex justify-space-between align-center">
            <span style="font-size: 24px; font-weight: bold; color: #000;">Service Request - {{ item.id }}</span>
            <v-btn
              v-if="item.is_archived === 0"
              @click="syncEmails"
            >
              <v-icon class="mr-2">
                mdi-refresh
              </v-icon>
              REFRESH Emails
            </v-btn>
          </div>

          <!-- <div
            class="d-flex ga-3 pa-1"
            style="background: #F3F4F6; border-radius: 4px;"
          >
            <div
              v-for="tab in tabs"
              :key="tab.value"
              class="d-flex align-center justify-center pa-1"
              :style="`width: 100%; cursor: pointer; border-radius: 4px; ${ tab.value === selectedTab ? 'background: white;' : '' }`"
              @click="selectedTab = tab.value"
            >
              <span
                class="f9 fw500"

              >{{ tab.title }}</span>
            </div>
          </div> -->
          <v-tabs
            v-model="selectedTab"
            grow
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab.value"
              :value="tab.value"
              class="pa-2"
            >
              <span
                class="f9 fw500"
              >{{ tab.title }} {{ tab.value === 2 && notifications.length > 0 ? `(${notifications.length})` : '' }}</span>
            </v-tab>
          </v-tabs>
          <div
            v-if="selectedTab === 0"
            class="d-flex flex-column ga-2"
          >
            <div class="d-flex ga-2">
              <div
                style="border: 1px solid rgb(228, 228, 231); border-radius: 10px; border-left: 4px solid #4AC657;"
                class="d-flex flex-column ga-2 pa-5 w100"
              >
                <div class="d-flex align-center ga-1">
                  <v-icon style="font-size: 18px">
                    mdi-check-circle-outline
                  </v-icon>
                  <span
                    class="fw500 f9"
                  >Status</span>
                </div>

                <div>
                  <v-chip
                    v-if="item.status"
                    class="ma-1"
                    small
                    text-color="white"
                    :color="item.status.color"
                  >
                    {{ item.status.name }}
                  </v-chip>
                </div>
              </div>
              <div
                style="border: 1px solid rgb(228, 228, 231); border-radius: 10px; border-left: 4px solid #5782F9;"
                class="d-flex flex-column ga-2 pa-5 w100"
              >
                <div class="d-flex align-center ga-1">
                  <v-icon style="font-size: 18px">
                    mdi-file-document-check-outline
                  </v-icon>
                  <span
                    class="fw500 f9"
                  >Category</span>
                </div>
                <div class="d-flex flex-wrap">
                  <v-chip
                    v-for="(category) in item.categories"
                    :key="category.id"
                    class="ma-1"
                    small
                    text-color="white"
                    :color="category.color"
                  >
                    <span style="color: #fff; text-transform: uppercase"> {{ category.name }} </span>
                  </v-chip>
                  <div v-if="item.water_test_date" class="d-flex flex-column w100">
                    <span>Water Test Date: </span>
                    <span class="sub-label">{{ item.water_test_date }}</span>
                  </div>
                </div>
              </div>
              <div
                style="border: 1px solid rgb(228, 228, 231); border-radius: 10px; border-left: 4px solid #A753FA;"
                class="d-flex flex-column pa-5 w100 ga-1"
              >
                <div class="d-flex align-center ga-1">
                  <v-icon style="font-size: 18px">
                    mdi-clock-outline
                  </v-icon>
                  <span
                    class="fw500 f9"
                  >Timeline</span>
                </div>
                <div class="d-flex flex-column w100">
                  <span>Requested: </span>
                  <span class="sub-label">{{ item.created_at }}</span>
                </div>
                <div class="d-flex flex-column w100">
                  <span>Last Updated: </span>
                  <span class="sub-label">{{ item.updated_at }}</span>
                </div>
                <div
                  v-if="item.booked_date"
                  class="d-flex flex-column w100"
                >
                  <span>Booked Date: </span>
                  <span class="sub-label">{{ item.booked_date }}</span>
                </div>
                <div
                  class="d-flex flex-column ga-1"
                >
                  <div
                    class="d-flex flex-column pa-2"
                    style="background: #F3F4F6; border-radius: 4px;"
                  >
                    <div class="d-flex align-center ga-1">
                      <span
                        class="f9 fw500"
                      >Preferred Dates</span>
                      <v-icon
                        v-if="item.is_archived === 0"
                        style="font-size: 18px; cursor: pointer"
                        color="primary"
                        @click="openDateForm"
                      >
                        mdi-pencil
                      </v-icon>
                    </div>

                    <span v-if="item.preferred_date_primary">
                      From: {{ item.preferred_primary_formatted }} - To: {{ item.preferred_secondary_formatted }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-5 pa-5"
            >
              <div
                class="d-flex align-center ga-1"
              >
                <v-icon style="font-size: 25px">
                  mdi-account-outline
                </v-icon>
                <span
                  class="fw500 f7"
                >Contact Information</span>
              </div>
              <div class="d-flex align-center justify-center">
                <div class="d-flex flex-column w100">
                  <span

                    class="fw500 f9"
                  >Requester Name</span>
                  <span class="sub-label">{{ item.contact_name }}</span>
                </div>
                <div class="d-flex flex-column w100">
                  <span

                    class="fw500 f9"
                  >Email</span>
                  <span class="sub-label">{{ item.contact_email }}</span>
                </div>
                <div class="d-flex flex-column w100">
                  <span

                    class="fw500 f9"
                  >Phone</span>
                  <span class="sub-label">{{ item.contact_phone }}</span>
                </div>
              </div>
            </div>
            <div
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-5 pa-5"
            >
              <div
                class="d-flex align-center ga-1"
              >
                <v-icon style="font-size: 25px">
                  mdi-map-marker-outline
                </v-icon>
                <span
                  class="fw500 f7"
                >Project & Location</span>
              </div>
              <div class="d-flex align-center justify-center">
                <div class="d-flex flex-column w100 mr-10">
                  <span
                    class="fw500 f9"
                  >Project Name</span>
                  <v-autocomplete
                    v-model="item.project_id"
                    :items="projects"
                    item-value="id"
                    item-text="name"
                    placeholder="Select Project"
                    clearable
                    outlined
                    hide-details
                    :disabled="item.is_archived === 1"
                  />
                  <!-- <span class="sub-label">{{ item.project ? item.project.name : '' }}</span> -->
                </div>

                <div class="d-flex flex-column w100">
                  <span
                    class="fw500 f9"
                  >Tower</span>
                  <span class="sub-label">{{ item.tower ? item.tower : '' }}</span>
                </div>
                <div class="d-flex flex-column w100">
                  <span
                    class="fw500 f9"
                  >Floor</span>
                  <span class="sub-label">{{ item.floor ? item.floor : '' }}</span>
                </div>
                <div class="d-flex flex-column w100">
                  <span
                    class="fw500 f9"
                  >Unit</span>
                  <span class="sub-label">{{ item.unit ? item.unit : '' }}</span>
                </div>
              </div>
              <div class="d-flex flex-column w100">
                <span
                  class="fw500 f9"
                >Address</span>
                <span class="sub-label">{{ item.address ? item.address : '' }}</span>
              </div>
            </div>

            <div
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-5 pa-5"
            >
              <div
                class="d-flex align-center ga-1"
              >
                <v-icon style="font-size: 25px">
                  mdi-account-switch
                </v-icon>
                <span
                  class="fw500 f7"
                >Assignment & Priority</span>
              </div>
              <div class="d-flex align-center justify-center ga-6">
                <div class="d-flex flex-column w100">
                  <span
                    class="fw500 f9"
                  >Priority</span>
                  <v-select
                    v-model="item.priority_id"
                    :items="priorities"
                    item-text="name"
                    item-value="id"
                    outlined
                    clearable
                    placeholder="Select Priority"
                    :disabled="item.is_archived === 1"
                  >
                    <template #item="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer; text-transform: uppercase"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                    <!-- eslint-disable-next-line vue/no-template-shadow -->
                    <template #selection="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer; text-transform: uppercase"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                  </v-select>
                </div>
                <div
                  v-if="roles.includes(userRoleIdManager) || roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdAssociate)"
                  class="d-flex flex-column w100"
                >
                  <span
                    class="fw500 f9"
                  >User Responsible</span>
                  <v-autocomplete
                    v-model="item.user_responsible_id"
                    :items="users"
                    :item-text="(user) => `${user.first_name} ${user.last_name}`"
                    item-value="id"
                    clearable
                    outlined
                    placeholder="Select User Responsible"
                    :disabled="item.is_archived === 1"
                  />
                </div>
                <div
                  v-else
                  class="d-flex flex-column w100"
                />
              </div>
            </div>
          </div>
          <div
            v-if="selectedTab === 1"
            class="d-flex flex-column ga-2"
          >
            <div
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-5 pa-5"
            >
              <div class="d-flex align-center ga-1">
                <v-icon style="font-size: 25px; color: #000">
                  mdi-file-document-outline
                </v-icon>
                <span
                  class="fw500 f7"
                >Issue Details</span>
              </div>
              <div
                v-if="item.job_description"
                class="d-flex flex-column ga-1"
              >
                <span

                  class="f9 fw500"
                >Subject</span>
                <div
                  class="pa-2"
                  style="background: #F3F4F6; border-radius: 4px;"
                >
                  <span>{{ item.job_description }}</span>
                </div>
              </div>

              <div
                v-if="item.description"
                class="d-flex flex-column ga-1"
              >
                <span

                  class="f9 fw500"
                >Detailed Description</span>
                <div
                  class="pa-2"
                  style="background: #F3F4F6; border-radius: 4px;"
                >
                  <span>{{ item.description }}</span>
                </div>
              </div>

              <div
                v-if="item.sectors && item.sectors.length > 0"
                class="d-flex flex-column ga-1"
              >
                <span

                  class="f9 fw500"
                >Unit info</span>
                <v-card
                  elevation="0"
                  outlined
                >
                  <v-data-table
                    :headers="headers"
                    :items="item.sectors"
                    dense
                    hide-default-footer
                  >
                    <template #[`item.name`]="{ item }">
                      <text-highlight
                        :queries="search"
                      >
                        {{ item.name }}
                      </text-highlight>
                    </template>
                  </v-data-table>
                </v-card>
              </div>
              <div
                v-if="item.attachments && item.attachments.length > 0"
                class="d-flex flex-column ga-2"
              >
                <span

                  class="f9 fw500"
                >Attachments</span>
                <div
                  v-for="attachment in item.attachments"
                  :key="attachment.id"
                  class="d-flex ga-1 align-center pa-2"
                  style="background: #F3F4F6; border-radius: 4px;"
                >
                  <v-icon style="font-size: 18px;color: #000">
                    mdi-paperclip
                  </v-icon>
                  <a @click="downloadAttachment(attachment)">{{ attachment.file_name }}</a>
                </div>
              </div>
            </div>
            <div
              v-if="item.categories.some(cat => cat.id === 9)"
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-5 pa-5"
            >
              <div class="d-flex align-center ga-1">
                <v-icon style="font-size: 25px; color: #000">
                  mdi-water-outline
                </v-icon>
                <span
                  class="fw500 f7"
                >Water Test Details</span>
              </div>

              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Interior / Exterior Caulking Completed</span>
                <span>{{ item.is_caulking_completed ? 'Yes' : 'No' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Exterior Finishes Completed</span>
                <div class="d-flex ga-3">
                  <div
                    v-for="finish in item.exterior_finishes"
                    :key="finish.id"
                  >
                    <span>{{ finish.name }}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Static or Cyclic Pressure Testing: </span>
                <span>{{ item.pressure_testing_type ? item.pressure_testing_type.name : 'N/A' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Specified Test Pressure:</span>
                <span>{{ item.test_pressure ? `${item.test_pressure} Pa` : 'N/A' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Spray Duration per Cycle (if cyclic):</span>
                <span>{{ item.spray_duration ? `${item.spray_duration} minutes` : 'N/A' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Total Duration of Test:</span>
                <span>{{ item.test_duration ? `${item.test_duration} minutes` : 'N/A' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Nozzle Type / Flow Rate:</span>
                <span>{{ item.nozzle_type ? `${item.nozzle_type} GPM` : 'N/A' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Ambient Weather Conditions (estimated):</span>
                <span>{{ item.weather_conditions ? `${item.weather_conditions}` : 'N/A' }}</span>
              </div>
              <div class="d-flex flex-column ga-1">
                <span
                  class="f9 fw500"
                >Samples Required for Testing:</span>
                <div class="d-flex ga-3">
                  <div
                    v-for="sample in item.samples"
                    :key="sample.id"
                  >
                    <span>{{ sample.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedTab === 2">
            <div
              style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
              class="d-flex flex-column ga-5 pa-5"
            >
              <div class="d-flex align-center ga-1">
                <v-icon style="font-size: 25px; color: #000">
                  mdi-message-outline
                </v-icon>
                <span
                  class="fw500 f7"
                >Communications ({{ notifications.length }})</span>
              </div>
              <div
                v-if="notifications && notifications.length > 0"
                class="d-flex flex-column ga-2"
              >
                <div
                  v-for="notification in notifications"
                  :key="notification.id"
                  style="border: 1px solid rgb(228, 228, 231); border-radius: 10px;"
                  class="d-flex flex-column ga-2 pa-3"
                >
                  <div class="d-flex justify-space-between">
                    <div class="d-flex align-center ga-2">
                      <v-chip
                        small
                        outlined
                        :color="notification.type.color"
                      >
                        <span style="text-transform: uppercase">{{ notification.type ? notification.type.name : '' }}</span>
                      </v-chip>
                      <span class="fw600"> {{ notification.is_client == 0 ? notification.user ? notification.user.first_name + ' ' + notification.user.last_name : item.contact_name : item.contact_name }}</span>
                      <span> {{ notification.is_client == 0 ? notification.user ? notification.user.email : item.contact_email : item.contact_email }}</span>
                    </div>
                    <span> {{ notification.created_at_short }}</span>
                  </div>
                  <div class="d-flex align-center ga-2">
                    <span
                      v-if="notification.type_id == typeIdEmail || notification.type_id == typeIdInternalNote"
                      style="max-width: 2000px; width: 1500px; overflow-y: auto;"
                      v-html="notification.text"
                    />
                    <span v-else>{{ notification.text }}</span>
                    <div
                      v-if="notification.type_id === typeIdStatuschange"
                    >
                      <span v-if="notification.from_status">from</span>
                      <v-chip
                        v-if="notification.from_status"
                        class="ma-1"
                        small
                        text-color="white"
                        :color="notification.from_status.color"
                      >
                        <span style="color: #fff; text-transform: uppercase">{{ notification.from_status.name }}</span>
                      </v-chip>

                      <span v-if="notification.to_status">to</span>
                      <v-chip
                        v-if="notification.to_status"
                        class="ma-1"
                        small
                        text-color="white"
                        :color="notification.to_status.color"
                      >
                        <span style="color: #fff; text-transform: uppercase">{{ notification.to_status.name }}</span>
                      </v-chip>
                    </div>
                    <div
                      v-if="notification.type_id === typeIdPriorityChange"
                    >
                      <span v-if="notification.from_priority">from</span>
                      <v-chip
                        v-if="notification.from_priority"
                        class="ma-1"
                        small
                        text-color="white"
                        :color="notification.from_priority.color"
                      >
                        <span style="color: #fff; text-transform: uppercase">{{ notification.from_priority.name }}</span>
                      </v-chip>

                      <span v-if="notification.to_priority">to</span>
                      <v-chip
                        v-if="notification.to_priority"
                        class="ma-1"
                        small
                        text-color="white"
                        :color="notification.to_priority.color"
                      >
                        <span style="color: #fff; text-transform: uppercase">{{ notification.to_priority.name }}</span>
                      </v-chip>
                    </div>

                    <div
                      v-if="notification.type_id === typeIdUserResponsibleChange"
                    >
                      <span v-if="notification.from_user">from </span>
                      <span v-if="notification.from_user">{{ notification.from_user ? notification.from_user.first_name + ' ' + notification.from_user.last_name : '' }}</span>

                      <span v-if="notification.to_user">to </span>
                      <span v-if="notification.to_user">{{ notification.to_user ? notification.to_user.first_name + ' ' + notification.to_user.last_name : '' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="sendNotificationTypeId != 0"
              class="d-flex flex-column ga-2 pt-3"
            >
              <span
                v-if="sendNotificationTypeId === 1"

                class="f9 fw500"
              >Add Internal Note</span>
              <span
                v-if="sendNotificationTypeId === 2"

                class="f9 fw500"
              >Send Email to Client</span>

              <VueEditor
                v-if="sendNotificationTypeId === 2 || sendNotificationTypeId === 1"
                v-model="form.text"
                :editor-toolbar="customToolbar"
              />

              <div class="d-flex justify-end ga-2">
                <v-btn
                  color="secondary"
                  @click="cancel"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  @click="submitNotification"
                >
                  SUBMIT
                </v-btn>
              </div>
            </div>
            <div
              v-if="sendNotificationTypeId == 0 && item.is_archived === 0"
              class="d-flex justify-end ga-2 pt-3"
            >
              <v-btn
                color="#4AC657"
                @click="addInternalNote"
              >
                <span style="color: #fff">Add Internal Note</span>
              </v-btn>
              <v-btn
                color="#5782F9"
                @click="addClientNote"
              >
                <span style="color: #fff">Send Email to Client</span>
              </v-btn>
            </div>
          </div>
        </div>
        <v-dialog
          v-model="dialogDate"
          max-width="900px"
          :persistent="true"
        >
          <v-form
            ref="form"
          >
            <v-card>
              <v-card-title>
                <span class="headline">Preferred Dates (Please select 2)</span>
              </v-card-title>
              <v-card-text>
                <v-date-picker
                  v-model="item.preferred_dates"
                  multiple
                  :allowed-dates="allowedDates"
                  full-width
                  range
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="normal"
                  class="mr-2"
                  @click="dialogDate = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="item.is_archived === 0"
                  color="primary"
                  @click="submit"
                >
                  SAVE
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { saveAs } from 'file-saver';

export default {
  components: {
    VueEditor,

  },
  props: {

  },
  data: () => ({
    item: null,
    form: null,
    itemDto: {
      id: 0,
      text: null,
      is_client: 0,
      type_id: null,
      stms_request_id: 0,
      priority_id: null,
      project_id: null,
      preferred_dates: [],
    },
    tabs: [
      { title: 'Overview', value: 0 },
      { title: 'Details', value: 1 },
      { title: 'Communications', value: 2 },
    ],
    selectedTab: 0,
    notifications: [],
    sendNotificationTypeId: 0,
    priorities: [],
    users: [],
    userRoleIdManager: 36,
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    typeIdInternalNote: 1,
    typeIdEmail: 2,
    typeIdLink: 3,
    typeIdStatuschange: 4,
    typeIdPriorityChange: 5,
    typeIdUserResponsibleChange: 6,
    statusIdNew: 1,
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
      ],
      [{ color: [] }],
    ],
    headers: [
      {
        text: 'Floor',
        value: 'floor',
      },
      {
        text: 'Unit',
        value: 'unit',
      },
      {
        text: 'Location',
        value: 'location',
      },
      {
        text: 'Description',
        value: 'description',
      },
    ],
    projects: [],
    dialogDate: false,

  }),
  computed: {
    ...mapState({
      user: 'user',
    }),
    ...mapGetters([

    ]),
  },
  watch: {
    selectedTab(newVal) {
      if (newVal === 2 && this.item && this.item.unread_notifications_count > 0) {
        this.setNotificationsRead();
      }
    },
    'item.preferred_dates': function (val) {
      // Prevent more than 2 dates
      if (val.length > 2) {
        this.item.preferred_dates = val.slice(0, 2);
      }
    },
  },
  created() {
    this.item = { ...this.itemDto };
    this.roles = this.user.roles.map((x) => x.id);
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.stmsRequest.read(submitModel);
      if (!res || !res.data || res.data.length < 1) return;
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async getNotifications(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          request_id: id,
          is_visible_user: 1,
          is_visible_client: 0,
        },
      };
      const res = await this.$api.stmsRequestNotification.read(submitModel);
      if (!res || !res.data || res.data.length < 1) return;
      this.notifications = res.data;
    },

    async getPriorities() {
      this.priorities = await this.$api.stmsPriority.get();
    },

    async getUsers() {
      const submitModel = {
        filters: {
          is_username: false,
        },
      };
      const res = await this.$api.user.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      if (res.length <= 0) {
        return;
      }
      this.users = res;
    },

    async getProjects() {
      const submitModel = {
        filters: {
          is_all: 1,
        },
      };
      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) { return; }
      if (!res || !res.data) {
        this.projects = [];
        return;
      }
      this.projects = res.data;
    },

    async submit() {
      this.item.created_by = this.user.id;
      if (this.item.preferred_dates.length > 0) {
        const preferredDatePrimary = this.item.preferred_dates[0] || null;
        const preferredDateSecondary = this.item.preferred_dates[1] || null;
        this.item.preferred_date_primary = preferredDatePrimary;
        this.item.preferred_date_secondary = preferredDateSecondary;
      }
      const res = await this.$api.stmsRequest.update(this.item);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      this.getNotifications(this.item.id);
      this.sendNotificationTypeId = 0;
      this.form.text = '';
      this.$refs.dialogBox.close();
    },

    async submitNotification() {
      const submitData = {
        stms_request_id: this.item.id,
        text: this.form.text,
        type_id: this.sendNotificationTypeId,
        is_client: 0,
        created_by: this.user.id,
      };

      const res = await this.$api.stmsRequestNotification.store(submitData);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      this.getNotifications(this.item.id);
      this.sendNotificationTypeId = 0;
      this.form.text = '';
    },

    cancel() {
      this.form.text = '';
      this.sendNotificationTypeId = 0;
    },

    open(id) {
      this.form = { ...this.itemDto };
      this.selectedTab = 0;
      this.get(id);
      this.getNotifications(id);
      this.getPriorities();
      this.getUsers();
      this.getProjects();
      this.sendNotificationTypeId = 0;
      this.$refs.dialogBox.open();
    },

    addInternalNote() {
      this.sendNotificationTypeId = 1;
    },

    addClientNote() {
      this.sendNotificationTypeId = 2;
    },

    async downloadAttachment(item) {
      const res = await this.$api.attachment.get(`download/${item.id}`, {
        responseType: 'blob',
      });
      const downloadedFile = new Blob([res]);
      saveAs(downloadedFile, item.file_name);
    },

    async syncEmails() {
      this.$bus.$emit('loading');
      const res = await this.$api.stmsRequestNotification.get('sync-emails');
      this.$bus.$emit('loading');

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.get(this.item.id);
    },

    async setNotificationsRead() {
      this.$api.stmsRequest.get(`set-notifications-read/${this.item.id}`);
      this.$emit('success');
    },

    allowedDates(date) {
      const d = new Date(date);
      const today = new Date();

      // Function to add business days (skip weekends)
      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const day = result.getDay();
          if (day !== 6 && day !== 5) { // skip Sunday & Saturday
            added++;
          }
        }
        return result;
      };

      // Get date that is 3 business days ahead
      const minDate = addBusinessDays(today, 3);

      const isWeekday = d.getDay() !== 6 && d.getDay() !== 5;
      const isAfterMinDate = d >= minDate;

      return isWeekday && isAfterMinDate;
    },

    openDateForm() {
      this.form.preferred_dates = [];
      this.dialogDate = true;
    },
  },
};
</script>

<style scoped>
.sub-label {
  font-size: 16px;
}

span{
  color: #000;
}
</style>
